export const BASE_URL = `${process.env.REACT_APP_BASE_URL}`;
export const API_URL = `${BASE_URL}/api`;

export const API_ANNOUNCEMENT_LIST = `${API_URL}/home/announcement/index.json`;
export const API_ARTICLE_LIST = `${API_URL}/home/article/index.json`;
